<!--购买记账组件-->
<template>
    <div>
        <!--面包屑导航-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>养殖日志</el-breadcrumb-item>
            <el-breadcrumb-item>购买记账</el-breadcrumb-item>
        </el-breadcrumb>
        <!--添加购买金额-->
        <el-button type="primary" icon="el-icon-plus" style="margin-bottom: 15px" @click="add">添加</el-button>
        <el-dialog title="添加购买金额" :visible.sync="dialogFormVisible">
            <el-form :model="form" :rules="rules" ref="form">
               <!-- <el-form-item label="购买金额" prop="price" :label-width="formLabelWidth">
                    <el-input v-model="form.price" autocomplete="off" placeholder="输入购买金额"></el-input>
                </el-form-item>-->
                <el-form-item label="购买物品类型" prop="name" :label-width="formLabelWidth">
                    <el-select @change="selectType" v-model="form.name" placeholder="选择购买物品类型">
                        <el-option  v-for="item in purchaseAccountList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="饵料" prop="feed" :label-width="formLabelWidth">
                    <el-select :disabled="isFeedAble" v-model="form.feed" placeholder="选择饵料">
                        <el-option  v-for="item in feedList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="水质改良剂" prop="drug" :label-width="formLabelWidth">
                    <el-select :disabled="isDrugAble" v-model="form.drug" placeholder="选择改良药剂">
                        <el-option  v-for="item in drugList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  label="购买数量" prop="count" :label-width="formLabelWidth">
                    <el-input style="width: 200px" :disabled="isCountAble" v-model="form.count" autocomplete="off" placeholder="输入购买数量" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                    <el-select style="width: 120px;display: inline-block" :disabled="isCountAble" v-model="form.unit" placeholder="选择单位">
                        <el-option  v-for="item in ['斤','升']" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="width: 340px" label="金额(总)" prop="price" :label-width="formLabelWidth">
                    <el-input v-model="form.total" autocomplete="off" placeholder="输入金额(总)"></el-input>
                </el-form-item>
                <el-form-item label="活动时间" :label-width="formLabelWidth">
                    <el-col :span="10">
                        <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="form.date" style="width: 100%;"></el-date-picker>
                    </el-col>
                    <el-col class="line" :span="1">----</el-col>
                    <el-col :span="10">
                        <el-time-picker placeholder="选择时间" value-format="HH:mm:ss" v-model="form.time" style="width: 100%;"></el-time-picker>
                    </el-col>
                </el-form-item>
                <el-form-item label="其他信息" prop="remark" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="form.remark" placeholder="请添加描述"></el-input>
                </el-form-item>
                <!--<el-form-item label="饵料" prop="feed" :label-width="formLabelWidth">
                    <el-select :disabled="isFeedAble" v-model="form.feed" placeholder="选择饵料">
                        <el-option  v-for="item in feedList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeAdd">取 消</el-button>
                <el-button type="primary" @click="submitPurchaseAccountAdd('form')">确 定</el-button>
            </div>
        </el-dialog>
        <!--更新购买金额-->
        <el-dialog title="更新购买金额" :visible.sync="updateDialogFormVisible">
            <el-form :model="updateForm" :rules="rules" ref="form">
                <el-form-item label="购买物品类型" prop="name" :label-width="formLabelWidth">
                    <el-select @change="selectType" v-model="updateForm.name" placeholder="选择购买物品类型">
                        <el-option  v-for="item in purchaseAccountList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="饵料" prop="feed" :label-width="formLabelWidth">
                    <el-select :disabled="isFeedAble" v-model="updateForm.feed" placeholder="选择饵料">
                        <el-option  v-for="item in feedList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="水质改良剂" prop="drug" :label-width="formLabelWidth">
                    <el-select :disabled="isDrugAble" v-model="updateForm.drug" placeholder="选择改良药剂">
                        <el-option  v-for="item in drugList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  label="购买数量" prop="count" :label-width="formLabelWidth">
                    <el-input style="width: 200px" :disabled="isCountAble" v-model="updateForm.count" autocomplete="off" placeholder="输入购买数量" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                    <el-select style="width: 120px;display: inline-block" :disabled="isCountAble" v-model="updateForm.unit" placeholder="选择单位">
                        <el-option  v-for="item in ['斤','升']" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="width: 340px" label="金额(单)" prop="total" :label-width="formLabelWidth">
                    <el-input v-model="updateForm.total" autocomplete="off" placeholder="输入金额(单)"></el-input>
                </el-form-item>
                <el-form-item label="活动时间" :label-width="formLabelWidth" prop="time">
                    <el-col :span="10">
                        <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="updateForm.date" style="width: 100%;"></el-date-picker>
                    </el-col>
                    <el-col class="line" :span="1">----</el-col>
                    <el-col :span="10">
                        <el-time-picker placeholder="选择时间" value-format="HH:mm:ss" v-model="updateForm.time" style="width: 100%;"></el-time-picker>
                    </el-col>
                </el-form-item>
                <el-form-item label="其他信息" prop="remark" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="updateForm.remark" placeholder="请添加描述"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeUpdate">取 消</el-button>
                <el-button type="primary" @click="makeHandleUpdate">确 定</el-button>
            </div>
        </el-dialog>
        <!--表格区域-->
        <el-table :data="tableData" border stripe v-loading="loading" style="width: 100%">
            <el-table-column prop="name" label="名称" align="center"></el-table-column>
            <el-table-column prop="total" label="购买金额" align="center"></el-table-column>
            <el-table-column prop="count" label="数量" align="center"></el-table-column>
            <el-table-column prop="sysTime" label="填写时间" align="center"></el-table-column>
            <el-table-column width="300" align="center" fixed="right" label="操作">
                <template slot-scope="scope">
                    <el-button @click="handleUpdate(scope.row)" type="primary" icon="el-icon-edit" size="medium">修改</el-button>
                    <el-button @click="handleDelete(scope.row)" type="danger" icon="el-icon-delete" size="medium">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页器-->
        <el-pagination background
                       layout="prev, pager, next"
                       :total="total"
                       :current-page="currentPage"
                       :page-size="pageSize"
                       style="text-align: center;margin-top: 10px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentPage" >
        </el-pagination>
    </div>
</template>

<script>
    import request from "../../../http/dialog";
    import {positiveNumber} from "../../../utils/validate";

    export default {
        name: "purchaseAccount",
        inject: ['reload'],
        data(){
            return{
                /*表格列表数据*/
                tableData: [],
                currentPage: 1, // 初始页
                pageSize: 8, //    每页的数据
                total:0,//列表数据
                form: {/*添加功能弹出表单*/
                    total:'',//price: '',/*投入品金额*/
                    name: '', /*投入品类型*/
                    feed:'',/*饵料*/
                    count:'',/*购买饵料数量*/
                    unit:'',//单位
                    date: '',/*年月日*/
                    time: '',/*时分秒*/
                    drug:'',//水质改良剂
                    remark:'',//用户描述信息
                },
                updateForm:{/* 更新功能表单*/
                    id:'',
                    total: '',/*投入品金额*/
                    name: '', /*投入品类型*/
                    feed:'',/*饵料*/
                    count:'',/*购买饵料数量*/
                    date: '',/*年月日*/
                    time: '',/*时分秒*/
                    drug:'',//水质改良剂
                    remark:'',//用户描述信息
                    unit:'',//单位
                },
                sysTime:'',//更新时间
                /*获取固定收入-->添加固定成本-->投入品类型列表*/
                purchaseAccountList:[],
                feedList:[],//饵料列表
                isFeedAble:true,//饵料下拉列表是否可用
                isCountAble:true, //数量框是否可用
                drugList:[],//改良药剂列表
                isDrugAble:true,//改良药剂下拉列表是否可用
                formLabelWidth: '120px', //表单宽度
                dialogFormVisible: false, /*增加弹出表单默认属性为false*/
                updateDialogFormVisible:false,/*更新弹出表单默认属性为false*/
                loading: true, //table区域加载
                rules: {
                    total: [
                        { validator: positiveNumber, trigger: 'blur' }
                    ],
                    name: [
                        { required: true, message: '请选择投入品类型', trigger: 'change' }
                    ],
                    feed: [
                        { message: '请选择饵料', trigger: 'change' }
                    ],
                    drug:[
                        { message: '请选择药品', trigger: 'change' }
                    ],
                    time:[
                        {required:true,message:'请选择时间', trigger:'change'}
                    ]
                }
            }
        },
        methods:{
            /*购买物品类型改变时触发*/
           async selectType(value){
               //console.log(this.tableData)
                if(value === '饵料'){
                    //改变表单项的状态
                    this.isFeedAble = false
                    this.isDrugAble = true
                    this.isCountAble = false
                    //清空非选择表单的值
                    this.form.drug = ''
                    let res = await request.getFeedList()
                    //console.log(res.data)
                    this.feedList = res.data
                }else if(value === '水质改良剂'){
                    this.isDrugAble = false
                    this.isFeedAble = true
                    this.isCountAble = false
                    this.form.feed = ''
                    let res = await request.getDrugList()
                  //  console.log(res.data)
                    this.drugList = res.data
                }else {
                    this.isDrugAble = true
                    this.isFeedAble = true
                    this.isCountAble = true
                    this.form.feed = ''
                    this.form.drug = ''
                    this.form.count = ''
                    this.form.unit = ''
                }
            },
            /*获取表格列表*/
            async getTableList(){
                let data = {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                }
                let table = await request.purchaseTableList(data)
                this.tableData = table.data.data.list
                this.total = table.data.data.total
                this.loading = false
                //console.log(table);
            },
            // 更新操作
            handleUpdate(data){
                // console.log(data);
                this.updateDialogFormVisible = true;
                this.updateForm = data
                this.sysTime = data.sysTime
                /*let sysTime = data.sysTime.split(' ') // 按照空格分隔时间
                // console.log(sysTime);
                this.updateForm.date = sysTime[0]
                this.updateForm.time = sysTime[1]*/
            },
            // 确认更新
            async makeHandleUpdate(){
                this.updateDialogFormVisible = false
                // console.log(this.updateForm);
                let sendData = { /*添加固定收入传入数据*/
                    type: 1, /*购买记账部分*/
                    id:this.updateForm.id,
                    total: this.updateForm.total,/*投入品金额*/
                    name: this.updateForm.name, /*投入品类型*/
                    count:this.updateForm.count,/*购买饵料数量*/
                    // total:this.updateForm.count * this.updateForm.price, // 总价
                    sysTime: this.sysTime ,/*用户自定义时间this.updateForm.date + ' '+this.updateForm.time*/
                    remark:this.updateForm.remark,//用户描述信息
                    unit:this.updateForm.unit,//单位
                    username: window.sessionStorage.getItem('name'), /*用户名*/
                }
                if (this.updateForm.feed){
                    sendData.name = this.updateForm.feed
                 //   console.log(this.updateForm.feed);
                }
                if (this.updateForm.drug){
                    sendData.name = this.updateForm.drug
                    //console.log(this.updateForm.drug);
                }
                // if (this.updateForm.drug === '环境改良类（底质改良、水质改良、生态条件改良）'){
                //     sendData.name = '环境改良类'
                //     // console.log('xiaonuo');
                // }
                if (this.updateForm.date && this.updateForm.time){
                    sendData.sysTime = this.updateForm.date + ' '+this.updateForm.time
                }
               // console.log(sendData.name);
               // console.log(sendData);
                let res = await request.updateStableIncome(sendData)
                //console.log("销售更新",res);
                if (res.data.msg === 'SUCCESS') {
                    this.$message.success('更新成功')
                    this.reload() // 局部刷新这里
                }else {
                    this.$message.info('更新失败')
                }
            },
            closeUpdate () { // 取消更新
                this.updateDialogFormVisible = false
                this.$message.info('取消更新')
            },
            // 删除操作
            handleDelete(data) {
                //console.log(data)
                this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let id = data.id
                   await request.deleteStableIncome(id)// 删除请求
                   // console.log(res);
                    this.reload();// 刷新页面显示最新状态
                    this.$message.success('删除成功!')
                }).catch(() => {
                    this.$message.info('已取消删除')
                })
            },
            // pageSize改变时触发
            handleSizeChange (size) {
                this.pagesize = size
               // console.log('handleSizeChange')
            },
            // 当前页面改变时触发
            handleCurrentPage (currentPage) {
               // console.log(currentPage)
                this.currentPage = currentPage
                //console.log('handleCurrentPage')
                this.getTableList()
            },
            /*添加购买金额按钮方法*/
            async add(){
                this.dialogFormVisible = true;
                /*获取购买物品类型列表*/
                // let res = await request.getPurchaseMoneyList()
                //console.log(res);
                // this.purchaseAccountList = res.data.data
            },
            async getPurchaseMoneyList(){/*获取购买物品类型列表*/
                let res = await request.getPurchaseMoneyList()
                this.purchaseAccountList = res.data.data
            },
            //添加购买记账请求
             submitPurchaseAccountAdd(form){
                this.$refs[form].validate(async(valid) => {
                    if (valid) {
                        this.dialogFormVisible = false
                        let addData = { /*添加购买记账传入数据*/
                            name: this.form.name,
                           // price: this.form.price,
                            total:this.form.total,
                            remark: this.form.remark,
                            count: this.form.count,
                            unit:this.form.unit,
                            type: 1,
                            sysTime: this.form.date + ' '+this.form.time ,/*用户自定义时间*/
                            username: window.sessionStorage.getItem('name')
                        }
                        if (this.form.feed){
                            addData.name = this.form.feed
                           // console.log(this.form.feed);
                        }
                        if (this.form.drug){
                            addData.name = this.form.drug
                           // console.log(this.form.drug);
                        }
                        // if (this.form.drug === '环境改良类（底质改良、水质改良、生态条件改良）'){
                        //     addData.name = '环境改良类'
                        //     // console.log('xiaonuo');
                        // }
                        //console.log(addData);
                        let tempAddData = await request.purchaseTableListAdd(addData)
                        if (tempAddData.data){
                            this.$message.success('添加成功')
                            location.reload()
                        }
                    } else {
                        //console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 取消添加
            closeAdd(){
                this.dialogFormVisible = false
                this.$message.info('取消添加')
            }
        },
        created() {
            this.getTableList() /*获取表格列表*/
        },
        mounted() {
            this.getPurchaseMoneyList() // 组件挂载时获取购买物品类型列表
        }
    }
</script>

<style scoped>
    /*使用深度选择器修改分页器颜色样式*/
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #1abc9c;
        color: #FFF;
    }
</style>
